import { css } from '@emotion/css';
import { Button, TextButton } from '@volumental/common';
import { type JSX } from 'react';
import { useTranslation } from 'react-i18next';
import { Modal } from '../../../components/modal/modal';
import { uiConfig } from '../../../services/config';

const common = css`
  font-family: ${uiConfig.styles.fontFamily};
  font-style: normal;
  color: ${uiConfig.styles.colors.black};
`;
const header = css`
  ${common}
  font-weight: ${uiConfig.styles.fontWeights.bold};
  font-size: 21px;
  margin-bottom: 24px;
  margin-top: 24px;
`;
const descriptionStyle = css`
  ${common}
  font-weight: ${uiConfig.styles.fontWeights.regular};
  font-size: ${uiConfig.styles.fontSizes.regular};
  line-height: 21px;
  margin-bottom: 24px;
`;
interface ExitProps {
  onCloseModal: () => void;
  onCloseExperience: () => void;
  onSkip: () => void;
  show: boolean;
}

export function SkipToRecomModal({
  onCloseExperience,
  onCloseModal,
  onSkip,
  show,
}: ExitProps): JSX.Element {
  const { t } = useTranslation();

  return (
    <Modal
      show={show}
      fitContent
      close={onCloseModal}
      modalTitle={t('hybrid.introExit.title')}
    >
      <div className={header}>{t('hybrid.introExit.title')}</div>
      <div className={descriptionStyle}>
        {t('hybrid.introExit.description')}
      </div>
      <div
        style={{ paddingBottom: 30, display: 'flex', flexDirection: 'column' }}
      >
        <Button loading={false} type="submit" onClick={onSkip}>
          {t('hybrid.introExit.seeBestSize')}
        </Button>
        <TextButton onClick={onCloseExperience}>
          {t('hybrid.introExit.leave')}
        </TextButton>
      </div>
    </Modal>
  );
}
